export enum ContactSubscription {

    to = 'to',
    from = 'from',
    both = 'both',
    none = 'none'

}
